import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiDelete, apiGet, apiPost } from '../../lib/api';

export const notificationsKey = (params) => ['notifications', params || {}];

export function useNotifications(params = {}) {
  const q = new URLSearchParams();
  if (params.status) q.set('status', params.status);
  if (params.severity) q.set('severity', params.severity);
  if (params.q) q.set('q', params.q);
  if (params.page) q.set('page', String(params.page));
  if (params.page_size) q.set('page_size', String(params.page_size));
  const qs = q.toString();
  return useQuery({
    queryKey: notificationsKey(params),
    queryFn: () => apiGet(`/notifications${qs ? `?${qs}` : ''}`),
  });
}

export function useAcknowledgeNotification() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => apiPost(`/notifications/${id}/acknowledge`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  });
}

export function useResolveNotification() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => apiPost(`/notifications/${id}/resolve`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  });
}

export function useDismissNotification() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => apiDelete(`/notifications/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  });
}

/** List the active client's members so an alert can be addressed to one. */
export function useNotificationRecipients(opts = {}) {
  return useQuery({
    queryKey: ['notifications', 'recipients'],
    queryFn: () => apiGet('/notifications/recipients'),
    enabled: opts.enabled !== false,
  });
}

/** Create a new alert. Body shape: { user_id?, type, title, body?, payload? } */
export function useCreateNotification() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => apiPost('/notifications', body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  });
}
